/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 25.07.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import Dropdown from 'react-dropdown';

import _find from 'lodash/find';

import Translate from '../../../../../components/Translate';

import { NarLocaleChange } from '../../../../../actions/_extentions/nar/actions-nar';

class SelectLanguageTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      curLocale: {}
    };
  }

  componentDidMount() {
    let locale = _find(this.props.locales, {value: this.props.locale});

    if (locale) this.setState({curLocale: locale});
  }

  _onLocaleSelect = (locale) => {
    this.setState({curLocale: locale});

    this.props.NarLocaleChange(locale.value);
  };

  render() {

    return (<div id="select_language">
      <label> <Translate content="settings.tabs.language.select_language" /> </label>
      <Dropdown options={this.props.locales} onChange={this._onLocaleSelect} value={{...this.state.curLocale}} placeholder="Select an option"/>
    </div>);
  }
}

SelectLanguageTab.propTypes = {
  locales: PropTypes.array,
  locale: PropTypes.string
};

const mapStateToProps = function ({common: {locales, locale}}) {

  return {locales, locale};
};

const mapDispatchToProps = function (dispatch) {

  return bindActionCreators({NarLocaleChange}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectLanguageTab);



// WEBPACK FOOTER //
// ./src/containers/Settings/Tabs/_extentions/nar/nar-select-language.js